import { Layout } from "../components/Layout";
import { ListAnimals } from "../modules/animals/elements/list-animals";

const PageAnimals = () => (
  <Layout>
    <ListAnimals />
  </Layout>
);

export default PageAnimals;
